module.exports = __webpack_public_path__ + "static/media/header_dark.8885f917.png";